import React, {useState, useEffect} from "react";
import moment from "moment";
import {TableWrapper} from "../TableWrapper/TableWrapper";
import {paymentContractActivityStatuses} from "constants/constants";
import {Button, Popconfirm, Tag, Tooltip, Space, message} from "antd";
import {EyeOutlined, UploadOutlined} from "@ant-design/icons";
import styled from "styled-components";
import {SubCompanyPaymentContractDetail} from "./SubCompanyPaymentContractDetail/SubCompanyPaymentContractDetail";
import {useStore} from "hooks/useStore";
import {ViewContractFileModal} from "./ViewContractFileModal/ViewContractFileModal";

const TableCellWrapper = styled.div`
    @media (max-width: 768px) {
        text-align: right !important;
    }
`;

export const SubCompanyPaymentContractsTable = ({
    subCompanyPaymentContracts = [],
    size = "large",
    refetch = async () => {},
    showTitle = true,
    ...props
}) => {
    const stores = useStore();
    const [selectedContractId, setSelectedContractId] = useState(null);
    const [uploadModalVisible, setUploadModalVisible] = useState(false);
    const [viewModalVisible, setViewModalVisible] = useState(false);
    const [documentUrl, setDocumentUrl] = useState(null);
    const [documentType, setDocumentType] = useState(null);

    const handleCancelContract = async ({contractId}) => {
        try {
            await stores.companyStore.cancelSubCompanyPaymentContract({contractId});
            await refetch();
        } catch (error) {
            message.error(error.message);
        }
    };

    const handleCloseUploadModal = () => {
        setUploadModalVisible(false);
        setSelectedContractId(null);
    };

    const handleUploadSuccess = async () => {
        await refetch();
    };
    const [loading, setLoading] = useState(false);
    const handleViewContract = async contractId => {
        try {
            setViewModalVisible(true);
            setLoading(true);

            const response = await stores.companyStore.getUploadedSubCompanyPaymentContract({
                contractId
            });

            if (response?.data?.file?.data && Array.isArray(response.data.file.data)) {
                const byteArray = new Uint8Array(response.data.file.data);
                const blob = new Blob([byteArray], {type: response.data.mimeType});
                const blobUrl = URL.createObjectURL(blob);

                setDocumentUrl(blobUrl);
                setDocumentType(response.data.mimeType);
                setLoading(false);
                return;
            }

            message.error("Dosya bulunamadı");
            setViewModalVisible(false);
            setLoading(false);
        } catch (error) {
            message.error(error.message || "Dosya görüntülenirken bir hata oluştu");
            setViewModalVisible(false);
            setLoading(false);
        }
    };

    const handleCloseViewModal = () => {
        if (documentUrl) {
            URL.revokeObjectURL(documentUrl);
        }
        setViewModalVisible(false);
        setDocumentUrl(null);
        setDocumentType(null);
        setLoading(false);
    };
    useEffect(() => {
        return () => {
            if (documentUrl) {
                URL.revokeObjectURL(documentUrl);
            }
        };
    }, [documentUrl]);

    const columns = [
        {
            title: "Detay",
            dataIndex: "_id",
            render: (_id, record) => (
                <TableCellWrapper>
                    <SubCompanyPaymentContractDetail subCompanyPaymentContract={record} key={_id} />
                </TableCellWrapper>
            )
        },
        {title: "Sözleşme Id", dataIndex: "contractId"},
        {
            title: "Başlangıç Tarihi",
            dataIndex: "startDate",
            render: date => (date ? moment(date).format("DD.MM.YYYY") : "-")
        },
        {
            title: "Bitiş Tarihi",
            dataIndex: "endDate",
            render: date => (date ? moment(date).format("DD.MM.YYYY") : "-")
        },
        {
            title: "Durumu",
            dataIndex: "activityStatus",
            style: {height: "500px"},
            render: (activityStatus, record) => (
                <TableCellWrapper>
                    <Tag
                        color={
                            paymentContractActivityStatuses?.find(
                                status => status?.value === activityStatus
                            )?.color
                        }
                    >
                        {paymentContractActivityStatuses?.find(
                            status => status?.value === activityStatus
                        )?.name || activityStatus}
                    </Tag>
                </TableCellWrapper>
            )
        },
        {
            title: "Aksiyon",
            dataIndex: "activityStatus",
            render: (activityStatus, record) => (
                <TableCellWrapper>
                    <Space size="small">
                        {record.signedContractFiles && record.signedContractFiles.length > 0 && (
                            <Tooltip title="Sözleşmeyi Görüntüle">
                                <Button
                                    type="link"
                                    size="small"
                                    icon={<EyeOutlined />}
                                    onClick={() => handleViewContract(record._id)}
                                >
                                    Görüntüle
                                </Button>
                            </Tooltip>
                        )}

                        {stores.meStore.checkRole("cancelSubCompanyFuturePaymentContracts") &&
                            activityStatus === "future" && (
                                <Popconfirm
                                    title="Bu kontratı iptal etmek istediğinize emin misiniz?"
                                    onConfirm={() => handleCancelContract({contractId: record._id})}
                                    okText="Evet"
                                    cancelText="Hayır"
                                >
                                    <Button type="danger" size="small" danger>
                                        İptal Et
                                    </Button>
                                </Popconfirm>
                            )}
                    </Space>
                </TableCellWrapper>
            )
        }
    ];
    return (
        <>
            <TableWrapper
                rowKey="_id"
                dataSource={subCompanyPaymentContracts}
                columns={columns.filter(column => !column.hidden) || []}
                size={size}
                pagination={false}
                renderTitle={() =>
                    showTitle && (
                        <h3 style={{fontWeight: 700, fontSize: 20}}>Alt Firma Sözleşmeleri</h3>
                    )
                }
                {...props}
            />
            <ViewContractFileModal
                visible={viewModalVisible}
                onCancel={handleCloseViewModal}
                documentUrl={documentUrl}
                documentType={documentType}
                loading={loading}
            />
        </>
    );
};
